export default __webpack_public_path__ + "static/media/supp.e2f3566f.svg";